import React from "react";
import { gameModes } from "../game/modes/definitions";
import "../styles/Layout.css";
import "../styles/Components.css";
import "../styles/Screens.css";

const StartScreen = ({ onSelectMode, onNavigate }) => {
  const handleButtonClick = (key) => {
    console.log("Button clicked:", key); // Debug log
    onSelectMode(key);
  };

  return (
    <div className="start-screen">
      <div className="start-background">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/boxgym.png`}
          alt="PunchFit AI"
          className="logo-image"
        />
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/intro-char.png`}
          alt="Character"
          className="intro-character"
        />
      </div>
      <div className="selection-buttons">
        {Object.entries(gameModes).map(([key, mode]) => (
          <button
            className="btn-mode"
            key={key}
            onClick={() => handleButtonClick(key)}
            onTouchStart={(e) => {
              console.log("Touch start:", key); // Debug log
              e.stopPropagation();
            }}
            onTouchEnd={(e) => {
              console.log("Touch end:", key); // Debug log
              e.stopPropagation();
            }}
          >
            {mode.name}
          </button>
        ))}
      </div>
      <footer className="legal-footer">
        <button
          className="legal-link"
          onClick={() => onNavigate("datenschutz")}
        >
          Datenschutz
        </button>
        <span className="legal-separator">|</span>
        <button className="legal-link" onClick={() => onNavigate("impressum")}>
          Impressum
        </button>
      </footer>
    </div>
  );
};

export default StartScreen;
